import React from 'react';
import * as orderActions from '../actions/orderActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { List, Avatar, Input } from 'antd';
import clear_logo from '../assets/img/clear.svg';
const InputGroup = Input.Group;


const Order = ({order, ...props}) =>{

    const calculateTotal = (lines) =>{
        let total = 0;
        lines.forEach((line, index) => {
            let price = parseFloat(line.price);
            let quantity = parseFloat(line.quantity);
            total = total + (price * quantity);
        });
        total = total.toFixed(2);
        return total;
    };

    const modifyLine = (key, event, line, field) => {
        let newValue = (event.target && event.target.value) ? event.target.value : 0;
        let newLines = order.lines;
        for (let i = 0; i < newLines.length; i++) {
            if(newLines[i].key == key) (newLines[i])[field] = newValue;
        }
        let newTotal = calculateTotal(newLines);
        props.actions.modifyOrderLine(newLines, newTotal);
    };

    const removeLine = (key) => {
        let newLines = order.lines;
        let indexToDelete = 0;
        for (let i = 0; i < newLines.length; i++) {
            if(newLines[i].key == key) indexToDelete = i;
        }
        newLines.splice(indexToDelete, 1);
        let newTotal = calculateTotal(newLines);
        props.actions.removeOrderLine(newLines, newTotal);
    }

    return(
        <div style={{height: 'calc(100% - 112px)', maxHeight: 'calc(100% - 112px)', overflowY: 'auto'}}>
            <List
                style={{height: '100%'}}
                loading={false}
                split={false}
                itemLayout="horizontal"
                dataSource={order.lines}
                renderItem={orderLine => (

                    <List.Item key={orderLine.key} className="bill-list-item">
                        <List.Item.Meta
                            avatar={<Avatar src={orderLine.img} />}
                            title={orderLine.title}
                            className="list-item-meta"
                        />
                        <div className="list-item-modifications">
                            <InputGroup size="small">
                                <div 
                                    style={{ 
                                        width: '5%', 
                                        float: 'right', 
                                        alignItems: 'center', 
                                        justifyContent: 'center', 
                                        marginRight: '8px', 
                                        cursor: 'pointer'
                                    }} 
                                    onClick={(e) => removeLine(orderLine.key)}
                                >
                                    <img  src={clear_logo} alt="clear" />
                                </div>

                                <Input 
                                    style={{ width: '40%', float: 'right' }} 
                                    type="number" 
                                    min="0"
                                    step="1"
                                    addonAfter='U' 
                                    defaultValue={orderLine.quantity} 
                                    onChange={(e) => {modifyLine(orderLine.key, e, orderLine, 'quantity')}}
                                />

                                <Input 
                                    style={{ width: '45%', float: 'right' }} 
                                    type="number" 
                                    min="0"
                                    step="0.01"
                                    addonAfter='€' 
                                    defaultValue={orderLine.price} 
                                    onChange={(e) => {modifyLine(orderLine.key, e, orderLine, 'price')}}
                                />
                            </InputGroup>
                        </div>
                        <div className='bill-list-item-description'>
                            <p>{orderLine.model}</p>
                        </div>
                    </List.Item>

                )}
            />
        </div>
    )
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(orderActions, dispatch)
    };
}

const mapStateToProps = (state) => ({
    main: state.main,
    order: state.order
});

export default connect(mapStateToProps,mapDispatchToProps)(Order);


// WEBPACK FOOTER //
// ./src/components/Order.js